import React, { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { loadExtraTranslations } from '../../../translations/translation-dic'; 

function LanguageSelector() {
    const { i18n } = useTranslation();
    const [anchorEl, setAnchorEl] = useState(null);
    const availableLanguages = window.config.werfen_endpoint ? [{'en': 'English'}, {'es': 'Español'}] : [{'en': 'English'}, {'it': 'Italiano'}, {'de': 'Deutsch'}, {'es': 'Español'}, {'ca': 'Català'}, {'fr': 'Français'}];
    const handleOpenMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    const changeLanguage = async (lng) => {
        if (!i18n.hasResourceBundle(lng, 'translation')) {
            const extra = await loadExtraTranslations([lng]);
            if (extra?.translation) {
                i18n.addResourceBundle(lng, 'translation', extra.translation);
            }
        }
        i18n.changeLanguage(lng);

        try {
            localStorage.setItem('lang', lng);
        } catch (e) {}

        handleCloseMenu();
    };

    return (
        <Fragment>
            <Button
                //variant="outlined"
                onClick={handleOpenMenu}
                sx={{  
                textDecoration: 'none', 
                color:"#3e699e", 
                backgroundColor: 'rgba(62, 105, 158, 0.1)', 
                padding:'10px',  
                width: '35px', 
                height: '35px', 
                borderRadius:'5px'}}
            >
                {i18n.language}
            </Button>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleCloseMenu}>

                {availableLanguages.map((lang) => (
                    <MenuItem key={Object.keys(lang)[0]} onClick={() => changeLanguage(Object.keys(lang)[0])}>
                        {Object.values(lang)[0]}
                    </MenuItem>
                ))}
            </Menu>
        </Fragment>
    );
}

export default LanguageSelector;